// src/App.js
import React, {useState} from 'react';
import Navbar from './components/NavBar';
import Home from './pages/Home';
import Packages from './pages/Packages';
import Contact from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import { Routes, Route } from 'react-router-dom';
import PackageList from './pages/PackageList';
import PackageDetails from './pages/PackageDetails';
import Footer from './components/Footer';
import EnquiryFormModal from './components/EnquiryFormModal';
import { Box, Button, Tooltip } from '@mui/material';
import InternationalPackage from './pages/InternationalPackage';
import DomesticPackage from './pages/DomesticPackages';
import DomAndIntPackageList from './pages/DomesticAndInternationalList';
import DomAndIntPackageDetails from './pages/domAndIntPackageDetails';
import ThemePackages from './pages/ThemePackages';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

function App() {
  const [openEnquiry, setOpenEnquiry] = useState(false);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor:"#f3f6f9"
      }}
    >
      <Navbar />
      <Tooltip title="Enquire Now">
        <Button
          onClick={() => setOpenEnquiry(true)}
          sx={{
            position: 'fixed',
            top: '50%',
            right: { xs: 16, sm: 24 },
            zIndex: 1300,
            background: 'linear-gradient(to right, #e96443, #904e95)',
            color: '#fff',
            minWidth: 'auto',
            p: 1.2,
            borderRadius: '50%',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            '&:hover': {
              background: 'linear-gradient(to right, #d6503f, #7d3e85)',
            }
          }}
        >
          <ChatBubbleOutlineIcon fontSize='medium' />
        </Button>
      </Tooltip>


      <Box sx={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/internationaltrips" element={<InternationalPackage />} />
          <Route path="/domestictrips" element={<DomesticPackage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/packages/:destinationId" element={<PackageList />} />
          <Route path="/packages/:destinationId/:packageId" element={<PackageDetails />} />
          <Route path="/internationaltrips/:destinationId" element={<DomAndIntPackageList />} />
          <Route path="/domestictrips/:destinationId" element={<DomAndIntPackageList />} />
          <Route path="/internationaltrips/:destinationId/:packageId" element={<DomAndIntPackageDetails />} />
          <Route path="/domestictrips/:destinationId/:packageId" element={<DomAndIntPackageDetails />} />
          <Route path="/themes/:themeName" element={<ThemePackages />} />

        </Routes>
      </Box>
      <Footer />
      <EnquiryFormModal open={openEnquiry} setOpen={setOpenEnquiry} page="Home" />
    </Box>
  );
}

export default App;
